import { Head, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import { employeesPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

import EmployeeForm from "./_form"

type PermissionCategories = Record<string, string[]>

interface EmployeeData {
  first_name: string
  last_name: string
  initials: string
  formal_name: string
  report_display_name: string
  job_title: string
  email: string
  username: string
  work_phone: string
  cell_phone: string
  home_phone: string
  status: string
  employment_type: number | null
  worker_type: number
  org_level: number | null
  pay_rate: number | null
  pay_type: number
  mileage_rate: number | null
  pto_days: number | null
  rdo_days: number | null
  sick_days: number | null
  specialty: string
  quickbooks_name: string
  quickbooks_vendor: string
  sig_profile: string
  sig_vcard: string
  sig_show_cell: boolean
  permissions: Record<string, boolean>
  roles: string[]
}

interface Props {
  employee: EmployeeData
  permission_categories: PermissionCategories
  role_options: string[]
  is_admin: boolean
  errors?: Record<string, string[]>
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Employees", href: "/employees" },
  { title: "New", href: "/employees/new" },
]

export default function New({
  employee,
  permission_categories,
  role_options,
  is_admin,
  errors,
}: Props) {
  const { data, setData, post, processing, transform } = useForm({
    ...employee,
    password: "",
    password_confirmation: "",
  })

  transform((data) => ({ employee: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(employeesPath())
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Employee" />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">New Employee</h1>

        <EmployeeForm
          data={data}
          setData={(key, value) =>
            setData(key as keyof typeof data, value as never)
          }
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Create Employee"
          permission_categories={permission_categories}
          role_options={role_options}
          isNew
          isAdmin={is_admin}
        />
      </div>
    </AppLayout>
  )
}
